import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    step: undefined,
};
export default createSlice({
    name: 'accordionSteps',
    initialState: initialState,
    reducers: {
        updateStep: (state, action) => {
            console.log('update step ' + action.payload);
            state.step = action.payload;
        },
    },
});
